import React from "react";
import { Loader2 } from "lucide-react";

export function SpinnerRow() {
  return (
    <div className="py-12 flex justify-center">
      <Loader2 className="w-5 h-5 animate-spin text-slate-400" />
    </div>
  );
}

export function EmptyBox({ text }) {
  return (
    <div className="rounded-2xl bg-white border border-slate-100 p-8 text-center text-sm text-slate-500">
      {text}
    </div>
  );
}

export function Panel({ title, children, testid, span2 = false }) {
  return (
    <div
      data-testid={testid}
      className={`rounded-2xl bg-white border border-slate-100 shadow-sm p-5 ${span2 ? "lg:col-span-2" : ""}`}
    >
      <h3 className="font-heading font-semibold text-base tracking-tight text-slate-950 mb-3">
        {title}
      </h3>
      {children}
    </div>
  );
}
